import { mkApp, mkWebsite } from './strings';

const mk = {
  translation: {
    ...mkWebsite,
    ...mkApp
  }
};

export default mk;
